import { useParams } from "react-router-dom";
import ExtendOrder from "./extendOrder";

export const ShowOrder = () => {
  const { id } = useParams();

  return <ExtendOrder row={{ id, onUpdate: () => {}, onDelete: () => {} }} />;
};
